import { ResourceOptions } from 'react-admin';
import { FaImage } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.banners;
export const icon = FaImage;
export const options: ResourceOptions = {
  label: 'resource.banners',
};






